import HeroImage from "../src/images/bg-intro-desktop.svg";
import Phone from "../src/images/image-mockups.png";

import { ReactComponent as Logo } from "../src/images/logo.svg";
import { ReactComponent as Hamburger } from "../src/images/icon-hamburger.svg";
import { ReactComponent as Close } from "../src/images/icon-close.svg";
import Online from "../src/images/icon-online.svg";
import Budget from "../src/images/icon-budgeting.svg";
import Onboard from "../src/images/icon-onboarding.svg";
import Api from "../src/images/icon-api.svg";

import money from "../src/images/image-currency.jpg";
import confetti from "../src/images/image-confetti.jpg";
import restaurant from "../src/images/image-restaurant.jpg";
import plane from "../src/images/image-plane.jpg";

import facebook from "../src/images/icon-facebook.svg";
import youtube from "../src/images/icon-youtube.svg";
import twitter from "../src/images/icon-twitter.svg";
import pinterest from "../src/images/icon-pinterest.svg";
import instagram from "../src/images/icon-instagram.svg";

export const herodata = {
  title: `Next generation digital banking`,
  subtitle: `sneaker`,
  btnText: "Request Invite",
  bgimage: HeroImage,
  phone: Phone,
};
export const navbardata = {
  Logo: Logo,
  btnText: "Request Invite",
  Hamburger: Hamburger,
  Close: Close,
};
export const detaildata = {
  online: Online,
  budget: Budget,
  onboard: Onboard,
  api: Api,
};

export const articledata = {
  money: money,
  confetti: confetti,
  restaurant: restaurant,
  plane: plane,
};

export const footerdata = {
  facebook: facebook,
  youtube: youtube,
  twitter: twitter,
  pinterest: pinterest,
  instagram: instagram,
  Logo: Logo,
};
